import { Component } from '@angular/core';

@Component({
  selector: 'app-cards-11',
  templateUrl: './cards-11.component.html'
})
export class Cards11Component {



    }
